import CryptoJS from 'crypto-js';

export default {
	//随机生成指定数量的16进制key
	generatekey() {
		let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let key = "";
		for (var i = 0; i < 16; i++) {
			let randomPoz = Math.floor(Math.random() * library.length);
			key += library.substring(randomPoz, randomPoz + 1);
		}
		return key;
	},

	//加密
	encrypt(data, keyStr, iv) {
		keyStr = keyStr ? keyStr : 'abcdsxyzhkj12345'; //判断是否存在ksy，不存在就用定义好的key
		let key = CryptoJS.enc.Utf8.parse(keyStr);
		let IV = CryptoJS.enc.Latin1.parse(iv);
		let encrypted = CryptoJS.AES.encrypt(data, key, {iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding, format: CryptoJS.format.Hex });
		return encrypted.toString();
	},
	//解密
	decrypt(word, keyStr, iv) {
		keyStr = keyStr ? keyStr : 'abcdsxyzhkj12345';
		let key = CryptoJS.enc.Utf8.parse(keyStr);
		let IV = CryptoJS.enc.Utf8.parse(iv);
		let decrypt = CryptoJS.AES.decrypt(word, key, {iv: IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding, format: CryptoJS.format.Hex });
		return CryptoJS.enc.Utf8.stringify(decrypt).toString();
	},

/*	// 2进制密文转16进制
	toHexadecimal(str){
		let val = "";
		for(var i = 0; i < str.length; i++){
			if (val == "")
				val = str.charCodeAt(i).toString(16);
			else
				val += str.charCodeAt(i).toString(16);
		}
		return val
	},
	// 16进制转2进制
	toBinary(str){
		var val="";
		var arr = str.split('');
		let arrCopy = []
		for(let i =0; i< arr.length; ){
			arrCopy.push(`${arr[i]}${arr[i+1]}`)
			i += 2;
		}
		arrCopy.forEach(res =>{
			val += String.fromCharCode(parseInt(res,16));
		})

		return val;
	}*/
}
